// extracted by mini-css-extract-plugin
module.exports = {"formInput":"FormInput_formInput__3hdJC","warning":"FormInput_warning__2I7K0"};